import type { CSSProperties } from 'react';

// import { useResizeDetector } from 'react-resize-detector';
import * as styles from '../navbarElement/Navbar.css';
import type { NavbarMenuListGroupElementProps } from '../navbarElement/Navbar.type';
import { cn } from '../utils/cn';

// const DEFAULTS = {
//   minHeight: '28px',
// };

export function NavbarMenuListGroupV2(props: NavbarMenuListGroupElementProps) {
  const { element, className, children, style, attributes } = props;
  const { type, customAttributes } = element.attrs || {};

  // const middleOuterRef = useRef<HTMLDivElement>(null);
  // const [maxWidth] = useState<number | null>(null);

  // const { height: middleWrapperHeight, ref: middleWrapperRef } = useResizeDetector({
  //   refreshMode: 'debounce',
  //   refreshRate: 100,
  // });

  // TODO: I'd love to keep this removed if we cant. this overflow is a terrible experience.
  // // Observe content width changes
  // useEffect(() => {
  //   if (!middleOuterRef.current || type !== 'middle') return;
  //   const leftSibling = middleOuterRef.current?.parentElement?.firstChild as HTMLDivElement;
  //   const rightSibling = middleOuterRef.current?.parentElement?.lastChild as HTMLDivElement;
  //   const parentElement = middleOuterRef.current?.parentElement;

  //   const updateMaxWidth = () => {
  //     const biggestSiblingWidth = Math.max(leftSibling?.scrollWidth || 0, rightSibling?.scrollWidth || 0);
  //     const parentWidth = parentElement?.scrollWidth || 0;
  //     setMaxWidth(parentWidth - biggestSiblingWidth * 2);
  //   };

  //   // Create observers for left and right siblings
  //   const resizeObserver = new ResizeObserver(updateMaxWidth);
  //   if (leftSibling) resizeObserver.observe(leftSibling);
  //   if (rightSibling) resizeObserver.observe(rightSibling);
  //   if (parentElement) resizeObserver.observe(parentElement);

  //   // Initial max width calculation
  //   updateMaxWidth();

  //   return () => {
  //     resizeObserver.disconnect();
  //   };
  // }, []);

  if (type === 'left') {
    return (
      <div
        {...props}
        {...attributes}
        {...customAttributes}
        className={cn('flex-1', styles.navbarMenuListGroup, styles.alignLeft, className)}
        style={
          {
            '--min-height': 'var(--height)',
            ...style,
          } as CSSProperties
        }
      >
        {children}
      </div>
    );
  }

  if (type === 'middle') {
    return (
      <div
        {...props}
        {...attributes}
        {...customAttributes}
        style={
          {
            ...style,
            '--min-height': 'var(--height)',
          } as CSSProperties
        }
        className={cn('shrink-0', styles.navbarMenuListGroup, styles.alignCenter, className)}
      >
        {children}
      </div>
    );
  }

  return (
    <div
      {...props}
      {...attributes}
      {...customAttributes}
      className={cn('flex-1', styles.navbarMenuListGroup, styles.alignRight, className)}
      style={
        {
          '--min-height': 'var(--height)',
          ...style,
        } as CSSProperties
      }
    >
      {children}
    </div>
  );
}
